import { z } from "zod"
import { coreTextLimits } from "@ibada/shared-types/common"

import {
  OfferingTypeScope,
  OfferingTypeStatus,
} from "@/features/church/config/offering-types/types/offering-type.types"

export type OfferingTypeFormInput = {
  name: string
  description?: string
  scope: OfferingTypeScope
  ownerBranchId?: string
  status: OfferingTypeStatus
}

type OfferingTypeSchemaMessages = {
  nameMin: string
  nameMax: string
  descriptionMax: string
  scopeRequired: string
  ownerBranchRequired: string
}

export const defaultOfferingTypeFormValues: OfferingTypeFormInput = {
  name: "",
  description: "",
  scope: OfferingTypeScope.PARISH,
  ownerBranchId: "",
  status: OfferingTypeStatus.ACTIVE,
}

export function createOfferingTypeFormSchema(messages: OfferingTypeSchemaMessages) {
  return z
    .object({
      name: z.string().trim().min(2, messages.nameMin).max(coreTextLimits.offeringTypeName, messages.nameMax),
      description: z.string().trim().max(coreTextLimits.offeringTypeDescription, messages.descriptionMax).optional().or(z.literal("")),
      scope: z.nativeEnum(OfferingTypeScope, { message: messages.scopeRequired }),
      ownerBranchId: z.string().optional(),
      status: z.nativeEnum(OfferingTypeStatus),
    })
    .superRefine((values, ctx) => {
      if (values.scope === OfferingTypeScope.BRANCH && !values.ownerBranchId?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["ownerBranchId"],
          message: messages.ownerBranchRequired,
        })
      }
    })
}
